import { generateMediaQueries, fadeInAnimation, color, font, convertToVariantValue } from '@lemonade-hq/cdk';
import { COLORS } from '@lemonade-hq/tokens';
import { rgba } from 'polished';
import { css } from 'styled-components';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  opacity: 0;\n  transform: scale(0.3);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  opacity: 1;\n  transform: scale(1);\n  transition: opacity 200ms ease-in-out, transform 200ms ease-in-out;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  opacity: 0;\n  transform: scale(0.3);\n  transition: opacity 200ms ease-in-out, transform 200ms ease-in-out;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  animation: ",
        " 0.2s ease-in-out;\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  background-color: ",
        ";\n  border-radius: 12px;\n  overflow: visible;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    animation: ",
        " 0.2s ease-in both;\n    opacity: 0;\n    padding: 8px 10px;\n    ",
        "\n    white-space: nowrap;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var structuredColors = {
    // text colors
    textPrimary: COLORS.night,
    textSecondary: COLORS.boulder,
    textTertiary: COLORS.dark,
    textDisabled: COLORS.metal,
    textDisabledSecondary: COLORS.light,
    textLink: COLORS.pink,
    textLinkPressed: COLORS.darkerPink,
    textNegative: COLORS.red,
    textPositive: COLORS.turquoise,
    invertedTextPrimary: COLORS.white,
    invertedTextSecondary: COLORS.metal,
    // background
    backgroundPrimary: COLORS.white,
    backgroundSecondary: COLORS.cloud,
    backgroundTertiary: COLORS.concrete,
    backgroundQuaternary: COLORS.glass,
    backgroundDisabled: COLORS.light,
    backgroundPositive: COLORS.turquoise,
    backgroundPositiveDark: COLORS.java,
    backgroundPositiveDarker: COLORS.caribbeanGreen,
    backgroundPending: COLORS.orange,
    backgroundNegative: COLORS.red,
    backgroundPink: COLORS.pink,
    backgroundPinkHover: COLORS.darkPink,
    backgroundPinkPressed: COLORS.darkerPink,
    backgroundPinkDisabled: COLORS.cupid,
    backgroundPinkLightHover: COLORS.pastelPink,
    backgroundPinkLighter: COLORS.tutu,
    invertedBackgroundPrimary: COLORS.darkerNight,
    invertedBackgroundSecondary: COLORS.darkMineShaft,
    // border colors
    borderPrimary: COLORS.glass,
    borderSecondary: COLORS.cloud,
    borderHover: COLORS.light,
    borderDark: COLORS.night,
    borderFocus: COLORS.pink
};
var DEFAULT_MAX_SCREEN_SIZES = {
    desktop: 1025,
    mobile: 768
};
var MEDIA_QUERIES = generateMediaQueries([
    DEFAULT_MAX_SCREEN_SIZES.mobile,
    DEFAULT_MAX_SCREEN_SIZES.desktop
]);
var mobile = DEFAULT_MAX_SCREEN_SIZES.mobile, desktop = DEFAULT_MAX_SCREEN_SIZES.desktop;
var DEFAULT_MOBILE_BREAKPOINT = "".concat(mobile, "px");
var DEFAULT_DESKTOP_BREAKPOINT = "".concat(desktop, "px");
var breakpoints = [
    DEFAULT_MOBILE_BREAKPOINT,
    DEFAULT_DESKTOP_BREAKPOINT
];
var fonts = {
    main: {
        fontFamily: "'Lato', 'Helvetica Neue', Arial, sans-serif",
        fontSize: "1.6rem",
        fontWeight: 400,
        lineHeight: 1.3
    },
    alt: {
        fontFamily: "'Merriweather', Georgia, serif",
        fontSize: "1.6rem",
        fontWeight: 400,
        lineHeight: 1.3
    },
    signature: {
        fontFamily: "'Dancing Script', Arial, sans-serif",
        fontSize: "1.6rem",
        fontWeight: 400,
        lineHeight: 1.3
    }
};
// dialog
var dialogTransitionPhaseEnter = css(_templateObject());
var dialogTransitionPhaseEnterActive = css(_templateObject1());
var dialogTransitionPhaseExitActive = css(_templateObject2());
var backdropStyle = css(_templateObject3(), fadeInAnimation(), function(param) {
    var theme = param.theme;
    return rgba(theme.colors.black, 0.7);
});
var dialogStyle = css(_templateObject4(), color("backgroundPrimary"));
// tooltip
var tooltip = {
    triangleSize: 6,
    borderRadius: 4,
    margin: 8,
    backgroundColorName: "darkerNight",
    colorName: "white",
    tooltipStyling: css(_templateObject5(), fadeInAnimation(), font("main", {
        fontSize: "14px",
        lineHeight: "17px"
    }))
};
var typography = convertToVariantValue({
    "headline-lg": {
        element: "h1",
        cssProps: {
            fontFamily: fonts.alt.fontFamily,
            fontWeight: 400,
            fontSize: "5.6rem",
            lineHeight: 1.3
        }
    },
    "headline-md": {
        element: "h2",
        cssProps: {
            fontFamily: fonts.alt.fontFamily,
            fontWeight: 400,
            fontSize: "3.6rem",
            lineHeight: 1.3
        }
    },
    "headline-sm": {
        element: "h3",
        cssProps: {
            fontFamily: fonts.alt.fontFamily,
            fontWeight: 400,
            fontSize: "2.8rem",
            lineHeight: 1.3
        }
    },
    "title-lg": {
        element: "h4",
        cssProps: {
            fontFamily: fonts.main.fontFamily,
            fontWeight: 700,
            fontSize: "4rem",
            lineHeight: 1.45
        }
    },
    "title-md": {
        element: "h5",
        cssProps: {
            fontFamily: fonts.main.fontFamily,
            fontWeight: 700,
            fontSize: "2.4rem",
            lineHeight: 1.45
        }
    },
    "title-sm": {
        element: "h6",
        cssProps: {
            fontFamily: fonts.main.fontFamily,
            fontWeight: 700,
            fontSize: "2rem",
            lineHeight: 1.45
        }
    },
    "body-lg": {
        element: "p",
        cssProps: {
            fontFamily: fonts.main.fontFamily,
            fontWeight: 400,
            fontSize: "1.8rem",
            lineHeight: 1.45
        }
    },
    "body-md": {
        element: "p",
        cssProps: {
            fontFamily: fonts.main.fontFamily,
            fontWeight: 400,
            fontSize: "1.6rem",
            lineHeight: 1.45
        }
    },
    "body-sm": {
        element: "p",
        cssProps: {
            fontFamily: fonts.main.fontFamily,
            fontWeight: 400,
            fontSize: "1.4rem",
            lineHeight: 1.45
        }
    },
    "label-lg": {
        element: "span",
        cssProps: {
            fontFamily: fonts.main.fontFamily,
            textTransform: "capitalize",
            fontWeight: 700,
            fontSize: "1.6rem",
            lineHeight: 1.45
        }
    },
    "label-md": {
        element: "span",
        cssProps: {
            fontFamily: fonts.main.fontFamily,
            textTransform: "capitalize",
            fontWeight: 700,
            fontSize: "1.4rem",
            lineHeight: 1.45
        }
    },
    "label-sm": {
        element: "span",
        cssProps: {
            fontFamily: fonts.main.fontFamily,
            textTransform: "capitalize",
            fontWeight: 700,
            fontSize: "1.2rem",
            lineHeight: 1.45
        }
    },
    "label-xs": {
        element: "span",
        cssProps: {
            fontFamily: fonts.main.fontFamily,
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "1rem",
            lineHeight: 1.45
        }
    }
});
// themes
var pinkishTheme = {
    name: "pinkish",
    breakpoints: breakpoints,
    fonts: fonts,
    colors: _object_spread(_object_spread_props(_object_spread({}, COLORS), {
        // Backwards compatibility
        primary: COLORS.pink,
        darkPrimary: COLORS.darkPink,
        darkerPrimary: COLORS.darkerPink
    }), structuredColors),
    structuredColors: structuredColors,
    dialog: {
        backdropStyle: backdropStyle,
        dialogStyle: dialogStyle,
        transitionPhases: {
            enter: dialogTransitionPhaseEnter,
            enterActive: dialogTransitionPhaseEnterActive,
            exitActive: dialogTransitionPhaseExitActive
        }
    },
    tooltip: tooltip,
    typography: typography
};
var reddishTheme = _object_spread_props(_object_spread({}, pinkishTheme), {
    name: "reddish",
    colors: _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, COLORS), {
        // Backwards compatibility
        primary: COLORS.red,
        darkPrimary: COLORS.darkRed,
        darkerPrimary: COLORS.darkerRed
    }), structuredColors), {
        backgroundPink: COLORS.red,
        backgroundPinkHover: COLORS.darkRed,
        backgroundPinkPressed: COLORS.darkerRed,
        borderPrimary: COLORS.red,
        borderHover: COLORS.darkRed,
        borderFocus: COLORS.darkerRed,
        textLink: COLORS.red,
        textLinkPressed: COLORS.darkerRed
    }),
    tooltip: tooltip,
    typography: typography
});
var _obj;
var themes = (_obj = {}, _define_property(_obj, pinkishTheme.name, pinkishTheme), _define_property(_obj, reddishTheme.name, reddishTheme), _obj);
var DEFAULT_THEME = pinkishTheme;

export { DEFAULT_MAX_SCREEN_SIZES, DEFAULT_THEME, MEDIA_QUERIES, fonts, pinkishTheme, reddishTheme, themes, tooltip };
